<template>
  <button class="btn" :class="getClass" :disabled="isDiasable" @click="action">
    <slot />
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    isDiasable: {
      type: Boolean,
      default: false,
    },
    sombras: {
      type: Boolean,
      default: false,
    },
    descarga: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getClass() {
      return {
        'btn-sombra': this.sombras,
      }
    },
  },
  methods: {
    action() {
        this.$emit('click');
    },
  },
}
</script>

<style scoped>



</style>
